import { createContext } from 'react';

const hemotherapyContext = createContext();

export default hemotherapyContext;
